/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import { AjaxError } from "rxjs/ajax";
import { ApiStatus } from "../Api";
import { AuthProviderClientConfig } from "./AuthProviders";
import AuthDefault from "./AuthDefault";

interface ApiAuthResponse {
   redirect: string;
}

export interface AuthOpenIdConnectConfig extends AuthProviderClientConfig {
   login: string;
   logout: string;
}

export class AuthOpenIdConnect extends AuthDefault {


   public async login(redirectUrl: string): Promise<void> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized.");

      return new Promise<void>((resolve, reject) => {

         const apiAuthRequest = this.api.call<void, ApiAuthResponse>(this.config.login, { redirect: redirectUrl });

         apiAuthRequest.subscribe({

            next: (response) => {
               if (!response.redirect) reject(new Error(`Unexpected server response.`));
               window.location.href = response.redirect;
               // resolve should never be reached as redirect should occur
               resolve();
            },

            error: (error: AjaxError) => {
               reject(new Error("Failed to call API.login: " + error.message));
            }

         })

      })

   }


   public async logout(redirectUrl: string = "/"): Promise<void> {

      if (this.api.status !== ApiStatus.Ready) throw new Error("API not initialized.");

      return new Promise<void>((resolve, reject) => {

         const apiAuthRequest = this.api.call<void, ApiAuthResponse>(this.config.logout, { redirect: redirectUrl });

         apiAuthRequest.subscribe({

            next: (response) => {
               if (response.redirect) window.location.href = response.redirect;
               // resolve should never be reached as redirect should occur
               resolve();
            },
            error: (error: AjaxError) => {
               reject(new Error("Failed to call API.logout: " + error.message));
            }

         })

      })
   }

}